import userStatistics from '@db2b/keystone/store/modules/callcenter/user_statistics'
import callTypes from '@db2b/keystone/store/modules/callcenter/call_types'
import proposalTypes from '@db2b/keystone/store/modules/callcenter/proposal_types'
import tags from '@db2b/keystone/store/modules/callcenter/tags'

import reminderCategories from './modules/reminder_categories'

export default {
  modules () {
    return {
      call_types: callTypes,
      proposal_types: proposalTypes,
      tags,
      reminder_categories: reminderCategories,
      user_statistics: userStatistics
    }
  },
  onLoad () {
    return [
      {type: 'action', name: 'reminder_categories/load'},
      {type: 'action', name: 'user_statistics/load'},
      {type: 'action', name: 'call_types/load'},
      {type: 'action', name: 'proposal_types/load'},
      {type: 'action', name: 'tags/load'}
    ]
  }
}




// WEBPACK FOOTER //
// ./src/store/index.js